'use client'

import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

import type { PublicSportType } from '@/features/sport-types/api/sportTypesApi'

import { normalizeLeaderboardSportCode } from '../buildLeaderboardSportTabs'
import FilterDropdown, { type FilterOption } from './FilterDropdown'

type SportFilterProps = {
  /** 'all' or a normalized sport code. */
  value: string
  onChange: (value: string) => void
  sportTypes: PublicSportType[]
}

export function SportFilter({ value, onChange, sportTypes }: SportFilterProps) {
  const t = useTranslations('leaderboardBoard')
  const options = useMemo(() => {
    const sports = sportTypes.reduceRight<FilterOption[]>((items, sport) => {
      items.push({
        value: normalizeLeaderboardSportCode(sport.code),
        label: sport.name
      })
      return items
    }, [])

    return [{ value: 'all', label: t('allSports') }, ...sports]
  }, [sportTypes, t])

  return (
    <FilterDropdown
      value={value}
      onChange={onChange}
      options={options}
      label={t('sportFilter')}
    />
  )
}
